@if (loginMode !== 'verify') { @if (widgetContext && showWidget) {
<cudc-ea-authenticate
  [hidden]="!isEnable"
  class="bl-display--block bl-margin-x--auto bl-padding-x--8"
  [widgetContext]="widgetContext"
  (widgetExportDataChange)="receivedDataHandler($event)"
  (widgetInfoStateChange)="receivedStateInfoHandler($event)"
  [validOverride]="consentsValid"
>
  @if (primaryAck) {
  <dx-consent
    [enabled]="true"
    [consent]="primaryAck"
    [required]="primaryAck.required"
    [(ngModel)]="primaryAck.isAccepted"
    [consents]="consentLibrary"
    (selectionChange)="captureConsent(primaryAck)"
    [fieldId]="'primary-econsent'"
    [name]="'primary-econsent'"
    [consentField]="consentField"
  ></dx-consent>
  @for (ack of additionalAck; track ack.acknowledgeId; let i = $index) {
  <dx-consent
    [enabled]="true"
    [consent]="ack"
    [required]="ack.required"
    [name]="'additional-econsent-' + i"
    [consents]="consentLibrary"
    (selectionChange)="captureConsent(ack)"
    [(ngModel)]="ack.isAccepted"
    [fieldId]="ack.acknowledgeId + '-' + i"
  ></dx-consent>
  } }
</cudc-ea-authenticate>

} } @else { @if (userId && verifyMethod) {
<dx-verify [userID]="userId" [method]="verifyMethod" (success)="receivedDataHandler($event)"></dx-verify>
} }
